// const sentimentFontRanges = [
//     { min: -1,   max: -0.4, font: 'Oswald', size: '19px' },
//     { min: -0.4, max: -0.1, font: 'Roboto Slab', size: '19px' },
//     { min: -0.1, max: 0.1, font: 'Open Sans', size: '19px' },
//     { min: 0.1, max: 0.3, font: 'Ubuntu', size: '19px' },
//     { min: 0.3, max: 1, font: 'Indie Flower', size: '2px' },
// ];
const sentimentFontRanges = [
    { min: -1,   max: -0.4, style:'font-family: Oswald; font-size: 19px; border-radius:0px !important;'},
    { min: -0.4, max: -0.1, style:'font-family: Roboto Slab; font-size: 19px; border-radius:0px !important;' },
    { min: -0.1, max: 0.1, style:'font-family: Open Sans; font-size: 19px; border-radius:0px !important;' },
    { min: 0.1, max: 0.3,  style:'font-family: Ubuntu; font-size: 19px; border-radius:8px !important;' },
    { min: 0.3, max: 1,  style:'font-family: Indie Flower; font-size: 22px; line-height: 20px; letter-spacing:0.7px;  border-radius:12px !important;' },
];

// const defaultStyle = { font: 'Open Sans', size: '12px' };
const defaultStyle = {style:'font-family: Open Sans; font-size: 12px'};

function getReasonFont(sentimentScore) {
    const selectedStyle = sentimentFontRanges.find(range => 
        sentimentScore >= range.min && sentimentScore < range.max
    ) || defaultStyle;

    // return `font-family:'${selectedStyle.font}' !important; font-size: ${selectedStyle.size}`;
    return selectedStyle.style;
}

export { getReasonFont };